import { standardProfile } from "./standard-dealer";
import { toshibaProfile } from "./Toshiba";
import { npoProfile } from "./NPO";

const profiles = new Map([
    ["standard-dealer", standardProfile],
    ["Toshiba", toshibaProfile],
    ["NPO", npoProfile]
]);

export function resolveProfile(code) {
    const profile = profiles.get(code);

    if (!profile) {
        throw new Error(
            `Profilo warehouse non riconosciuto: ${code}`
        );
    }

    return profile;
}